export default __webpack_public_path__ + "static/media/jobsBg.e8e2d307.webp";